import { render, staticRenderFns } from "./PreviewResourceInfo.vue?vue&type=template&id=7e8d7404&scoped=true&"
import script from "./PreviewResourceInfo.vue?vue&type=script&lang=js&"
export * from "./PreviewResourceInfo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewResourceInfo.vue?vue&type=style&index=0&id=7e8d7404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d7404",
  null
  
)

export default component.exports